import React from "react";
import { connect } from "react-redux";
import { getIsRequesting } from "../../Selectors/app";
import { authenticateGoogleCallback } from "./actions";
import { useEffect } from "react";
import { replace } from "yarrr";
import PageSpinner from "../../Components/Spinner/PageSpinner";
import { useDispatch } from "react-redux";

const GoogleCallback = (props) => {
	const { authenticateGoogleCallback } = props;
	const urlParams = new URLSearchParams(window.location.search);
	const code = urlParams.get("code");
	const dispatch = useDispatch();

	useEffect(() => {
		const handleCallback = async () => {
			if (code) {
				try {
					// authenticateGoogleCallback handles routing on success
					await authenticateGoogleCallback(code);
				} catch (error) {
					console.error("Google callback error: ", error);
					dispatch(replace("/login/"));
				}
			}
		};

		handleCallback();
	}, [code, authenticateGoogleCallback]);

	return <PageSpinner />;
};

const mapStateToProps = (state) => ({
	isRequesting: getIsRequesting(state, "OAUTH"),
});

const mapDispatchToProps = (dispatch) => ({
	authenticateGoogleCallback: (code) => dispatch(authenticateGoogleCallback(code)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GoogleCallback);
